(() => {
 function init(root = document) {
  root.querySelectorAll('[data-luuma-product]').forEach(card => {
   if (card.dataset.ready) return;
   card.dataset.ready = 'true';
   const select = card.querySelector('[data-luuma-variant]');
   select.addEventListener('change', () => {
    const option = select.selectedOptions[0], button = card.querySelector('[data-luuma-add]');
    card.querySelector('[data-luuma-price]').textContent = option.dataset.price;
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.label;
    const qty = card.querySelector('[name="quantity"]');
    qty.min = option.dataset.min || '1'; qty.step = option.dataset.step || '1'; qty.value = qty.min;
    if (option.dataset.max) qty.max = option.dataset.max; else qty.removeAttribute('max');
   });
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
document.addEventListener('click',event=>{const button=event.target.closest('[data-luuma-gallery-src]');if(!button)return;const gallery=button.closest('.luuma-bundled-gallery');gallery.querySelector('[data-luuma-gallery-main]').src=button.dataset.luumaGallerySrc;gallery.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});
